import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Heading, Box, ShadowBox, Button } from '@components/common';
import { TableHeading } from '@components/Typography';
import TableCell from '@components/TableCell';

import { SubscriptionSelectors } from '@redux/SubscriptionRedux';
import { stripePriceConverter } from '@services/transform';

function SubscriptionDetail(props) {
  const { activeSubscription, isPaused, isStopped, onStop } = props;

  if (!activeSubscription) {
    return null;
  }

  const {
    formattedFinalServiceDate,
    formattedNextScheduleStartDate,
    formattedResumeDate,
    cycle,
    lastBill
  } = activeSubscription;

  const renderCleanInfo = () => {
    return (
      <React.Fragment>
        <TableHeading mt={4} mb={4}>
          Routine details
        </TableHeading>

        {isStopped ? (
          <ShadowBox mb={4}>
            <TableCell
              title="Final service"
              rightText={formattedFinalServiceDate}
            />
          </ShadowBox>
        ) : (
          <ShadowBox mb={4}>
            {/* <TableCell
              title="Schedule Length"
              rightText={`${cycleLength} weeks`}
            /> */}

            {!isPaused && (
              <TableCell
                title="Renewal date"
                rightText={formattedNextScheduleStartDate}
              />
            )}
            {isPaused && <TableCell title="Paused" rightText="Yes" />}
            {isPaused && (
              <TableCell title="Resume date" rightText={formattedResumeDate} />
            )}
          </ShadowBox>
        )}
      </React.Fragment>
    );
  };

  const renderLastBill = () => {
    if (!lastBill) {
      return null;
    }

    const { formattedLastBillDate, price: lastBillPrice } = lastBill;

    return (
      <React.Fragment>
        <TableHeading mt={4} mb={4}>
          Your Last Bill
        </TableHeading>
        <ShadowBox mb={4}>
          <TableCell title="Payment date" rightText={formattedLastBillDate} />
          <TableCell
            title="Amount"
            rightText={`$${stripePriceConverter(lastBillPrice)}`}
          />
        </ShadowBox>
      </React.Fragment>
    );
  };

  const renderClean = (clean, index) => {
    const { serviceType, additionalService, serviceDate } = clean;
    const hasAdditional = additionalService && additionalService.length > 0;
    return (
      <TableCell
        key={`${serviceDate}_${index}`}
        title={`${serviceType}${hasAdditional ? ' +' : ''}`}
        leftIcon={serviceType}
        rightIcons={additionalService}
        rightIconColor="gold"
      />
    );
  };

  return (
    <React.Fragment>
      <Box flex={1} display="flex" flexDirection="column">
        <Box
          display={['none', 'flex']}
          flexDirection="row"
          justifyContent="space-between"
          mb={4}
        >
          <Heading py={0} my={0}>
            Routine Services
          </Heading>
        </Box>

        {renderCleanInfo()}
        {renderLastBill()}

        <Box flex={1} mt={4} display={['flex', 'none']} flexDirection="column">
          <TableHeading mt={0} px={2} mb={4} fontSize={2}>
            Routine Services
          </TableHeading>

          <ShadowBox mb={4}>{cycle.map(renderClean)}</ShadowBox>

          <Button
            variant="secondary"
            width={1}
            mt={2}
            mb={4}
            type="button"
            disabled={isStopped}
            onClick={onStop}
          >
            End services
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
}

SubscriptionDetail.propTypes = {
  activeSubscription: PropTypes.object,
  isStopped: PropTypes.bool,
  isPaused: PropTypes.bool,
  onPause: PropTypes.func,
  onStop: PropTypes.func
};

const mapStatesToProps = state => ({
  activeSubscription: SubscriptionSelectors.selectActiveSubscription(state),
  isStopped: SubscriptionSelectors.selectIsStopped(state),
  isPaused: SubscriptionSelectors.selectIsPaused(state)
});

export default connect(mapStatesToProps)(SubscriptionDetail);
